export const weightMetric = {
  isDefault: false,
  isPbEnabled: true,
  displayMetadata: { imperial: { decimals: null, unit: "Pound" }, metric: null },
  name: "Weight",
  field: "weight",
  unitOfMeasure: "Kilogram",
  sortType: 1,
};
